import { useFetchScheduleMembership } from './hooks/useFetchScheduleMembership'

class ScheduleMembershipService {
  membership = {
    useFetchScheduleMembership
  }
}

export * from './types/ScheduleMembership.schema'

export const scheduleMembershipService = new ScheduleMembershipService()
